"use client";

export default function StoreModal({ open, link, storeName, onClose }) {

  if (!open) return null;

  const getPreview = (url) => {
    if (!url) return "";
    if (url.includes("/view")) return url.replace("/view", "/preview");
    return url;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl p-5">

        <div className="flex justify-between mb-3">
          <div>
            <h3 className="font-semibold">Store Catalog</h3>
            <p className="text-xs text-zinc-500">{storeName}</p>
          </div>

          <button onClick={onClose}>✕</button>
        </div>

        <div className="h-80">
          <iframe
            src={getPreview(link)}
            className="w-full h-full border rounded"
          />
        </div>

        <div className="flex justify-end mt-4">
          <button
            onClick={() => window.open(link)}
            className="px-3 py-1 bg-[#00778B] text-white rounded"
          >
            Open Link
          </button>
        </div>

      </div>
    </div>
  );
}